import React, { useEffect, useRef } from 'react'
import PaymentInformation from '../modules/PaymentInformation'
import ThingsToKnow from '../modules/ThingsToKnow'
import globals from '../globals'
import { connect } from 'react-redux'
import CrossSellMobileModule from '../modules/CrossSellMobileModule'

const SimOnlyPlan = props => {
    const container = useRef(null)
    const thingsContainer = useRef(null)

    useEffect(() => {
        if (container) {
            globals.animatePageIn(container.current)
        }
    }, [])

    const goToThingsYouKnow = () => {
        window.scrollTo({
            top: thingsContainer.current.offsetTop,
            behavior: 'smooth'
        })
    }

    return (
        <div ref={container} style={{ opacity: 0 }}>
            <CrossSellMobileModule onScroll={goToThingsYouKnow} />
            <PaymentInformation className='spearmint-btn' />
            <div ref={thingsContainer}>
                <ThingsToKnow type='crossMobile' id='cross-mobile-things-to-know' />
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    customerId: state.auth.id
})

export default connect(mapStateToProps)(SimOnlyPlan)



// WEBPACK FOOTER //
// ./resources/js/pages/SImOnlyPlan.js